export default __webpack_public_path__ + "static/media/IMG_1169.219933f0.jpg";